import { CanapesStaticData } from './types';

export const CANAPES_STATIC_DATA: CanapesStaticData = {
  images: [
    '/images/static/catering/product/canapes/canapes1.jpg',
    '/images/static/catering/product/canapes/canapes2.jpg',
    '/images/static/catering/product/canapes/canapes3.jpg',
    '/images/static/catering/product/canapes/canapes4.jpg',
    '/images/static/catering/product/canapes/canapes5.jpg',
    '/images/static/catering/product/canapes/canapes6.jpg',
    '/images/static/catering/product/canapes/canapes7.jpg',
    '/images/static/catering/product/canapes/canapes8.jpg',
  ],
  prologue:
    'Mini Bites, Major Flavour: all made in-house with lean proteins and clean ingredients. Ideal for cocktail receptions, casual networking sessions, or post-workout nibbles.',
  multiplier: 12,
  servingSize: {
    fullBox: 24,
    halfBox: 12,
  },
  pricing: {
    halfBoxPrice: 66,
    discountThreshold: 300,
    discountRate: 0.1, // 10%
  },
  minOrder: {
    fullBox: 1,
    totalServings: 24,
  },
  deliveryFee: {
    cbd: 50,
    nonCbd: 40,
  },
  items: [
    {
      name: 'Yummy Tandoori Chicken with Mint Chutney',
      description:
        'Flavourful tandoori chicken on a stick paired perfectly with our zesty mint chutney and fresh parsley.',
    },
    {
      name: 'Yummy Satay Chicken with Alfalfa',
      description:
        'Succulent satay chicken skewers artfully paired with fresh alfalfa and crisp radish for a refined bite.',
    },
    {
      name: 'Yummy Basil Chicken on Bruchetta',
      description:
        'Tender Thai basil chicken perched on crisp bruschetta — a perfect appetiser.',
    },
    {
      name: 'Zesty Salmon with Alfalfa',
      description:
        'Bright and zesty salmon elegantly paired with fresh dill, crisp radish and alfalfa for a fresh finish.',
    },
    {
      name: 'Cheesy Beef Sliders',
      description:
        'Juicy lean beef sliders on toasted buns, layered with melty cheese and our signature guilt-free sauce.',
    },
  ],
};
